import { createAsyncThunk } from '@reduxjs/toolkit';
import * as Sentry from '@sentry/browser';

import { authUser, getUserData } from 'common/api';
import formatError from 'common/utils/formatError';

export const signInWithLoginOrEmail = createAsyncThunk(
  'user/sign-in',
  async (userData, thunkAPI) => {
    try {
      const { data } = await authUser(userData);
      return data;
    } catch (error) {
      return thunkAPI.rejectWithValue({
        error: formatError(error, 'Unauthorized'),
      });
    }
  },
);

export const getUser = createAsyncThunk(
  'user/get',
  async (userData, thunkAPI) => {
    try {
      const { data } = await getUserData();
      if (window.APP_CONFIG?.features?.SENTRY) {
        Sentry.setContext('User', data);
      }
      data.language && window.localStorage.setItem('lang', data.language);
      return data;
    } catch (error) {
      return thunkAPI.rejectWithValue('User not found');
    }
  },
);
